/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [订单有备注生成新越库波次设置↗](http://yapi.yishou.com/project/128/interface/api/33635) 的 **请求配置**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/WavePicking/setRemarkNewSurpassConfig`
 * @更新时间 `2022-06-14 14:59:41`
 */
const setRemarkNewSurpassConfigRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/setRemarkNewSurpassConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["remark_new_surpass"],
        properties: { remark_new_surpass: { type: "string", description: "备注生成新波次配置（0: 关闭，1:开启）" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setRemarkNewSurpassConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [订单有备注生成新越库波次设置↗](http://yapi.yishou.com/project/128/interface/api/33635) 的 **请求函数**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/WavePicking/setRemarkNewSurpassConfig`
 * @更新时间 `2022-06-14 14:59:41`
 */
export const setRemarkNewSurpassConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setRemarkNewSurpassConfigRequestConfig, requestData), ...args);
};
setRemarkNewSurpassConfig.requestConfig = setRemarkNewSurpassConfigRequestConfig;
/**
 * 接口 [未处理备注的波次是否可以正常分播配置↗](http://yapi.yishou.com/project/128/interface/api/33636) 的 **请求配置**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/WavePicking/setUnHandleRemarkConfig`
 * @更新时间 `2022-06-14 14:59:32`
 */
const setUnHandleRemarkConfigRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/setUnHandleRemarkConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["un_handle_remark"],
        properties: { un_handle_remark: { type: "string", description: " 未处理波次是否可正常分播（0: 关闭，1:开启）" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setUnHandleRemarkConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [未处理备注的波次是否可以正常分播配置↗](http://yapi.yishou.com/project/128/interface/api/33636) 的 **请求函数**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/WavePicking/setUnHandleRemarkConfig`
 * @更新时间 `2022-06-14 14:59:32`
 */
export const setUnHandleRemarkConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setUnHandleRemarkConfigRequestConfig, requestData), ...args);
};
setUnHandleRemarkConfig.requestConfig = setUnHandleRemarkConfigRequestConfig;
/**
 * 接口 [显示订单有备注生成新越库波次设置 ↗](http://yapi.yishou.com/project/128/interface/api/33643) 的 **请求配置**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `GET /erp/WavePicking/getRemarkNewSurpassConfig`
 * @更新时间 `2022-06-14 15:51:56`
 */
const getRemarkNewSurpassConfigRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/getRemarkNewSurpassConfig",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            remark_new_surpass: { type: "string", description: "生成新越库开关" },
            origin: { type: "string", description: "仓库" },
            origin_txt: { type: "string", description: "仓库名称" },
        },
    },
    requestFunctionName: "getRemarkNewSurpassConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [显示订单有备注生成新越库波次设置 ↗](http://yapi.yishou.com/project/128/interface/api/33643) 的 **请求函数**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `GET /erp/WavePicking/getRemarkNewSurpassConfig`
 * @更新时间 `2022-06-14 15:51:56`
 */
export const getRemarkNewSurpassConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRemarkNewSurpassConfigRequestConfig, requestData), ...args);
};
getRemarkNewSurpassConfig.requestConfig = getRemarkNewSurpassConfigRequestConfig;
/**
 * 接口 [显示未处理备注的波次是否可以正常分播配置↗](http://yapi.yishou.com/project/128/interface/api/33644) 的 **请求配置**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `GET /erp/WavePicking/getUnHandleRemarkConfig`
 * @更新时间 `2022-06-14 15:51:51`
 */
const getUnHandleRemarkConfigRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/getUnHandleRemarkConfig",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            un_handle_remark: { type: "string", description: "“未处理”备注的波次是否可以正常" },
            origin: { type: "string" },
            origin_txt: { type: "string" },
        },
    },
    requestFunctionName: "getUnHandleRemarkConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [显示未处理备注的波次是否可以正常分播配置↗](http://yapi.yishou.com/project/128/interface/api/33644) 的 **请求函数**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `GET /erp/WavePicking/getUnHandleRemarkConfig`
 * @更新时间 `2022-06-14 15:51:51`
 */
export const getUnHandleRemarkConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getUnHandleRemarkConfigRequestConfig, requestData), ...args);
};
getUnHandleRemarkConfig.requestConfig = getUnHandleRemarkConfigRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/wavePicking.js